
<template>
  <el-dialog
    class="relater-dialog"
    width="600px"
    :title="formData.is_relater ? '编辑成员' : '设为成员'"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    append-to-body
    :modal-append-to-body="false"
    @closed="onClose"
  >
    <el-form
      ref="postForm"
      v-loading="loading"
      label-position="left"
      label-width="120px"
      style="padding: 0 40px"
      :model="formData"
      :rules="formRules"
    >
      <el-form-item label="昵称" prop="relater">
        <div class="flex">
          <f-user-avatar :src="formData.avatar" shape="rounded" class="hd" style="width: 40px" />
          <span class="ml ellipsis">{{ formData.nickname }}</span>
        </div>
      </el-form-item>

      <el-form-item label="备注">
        <el-input v-model="formData.remark" placeholder="请填写备注名" />
      </el-form-item>

      <el-form-item label="权限" prop="default_auth">
        <el-select v-model="formData.default_auth" placeholder="请选择权限" style="width: 100%;" disabled @change="handleSelect">
          <el-option v-for="item in authArr" v-if="item.value" :key="item.value" :label="item.title" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item label="角色" prop="roleid">
        <Role-selector v-model="formData.roleid" placeholder="请选择角色" :disabled="is_owner && memberid == formData.memberid"  @getRoleList="getRoleList" />
      </el-form-item>

      <el-form-item label="自动绑定" prop="auto_bind">
        <el-switch v-model="formData.auto_bind" active-color="#07c160" :active-value="1" :inactive-value="0" />
        <span class="ml-sm text-muted">{{ '开启后，新设备将自动绑定，无需成员再扫码' }}</span>
      </el-form-item>
    </el-form>

    <div slot="footer" class="flex-center mb">
      <el-button class="extend" @click="dialogShow = false">取消</el-button>
      <el-button class="extend" type="primary" @click="submit">{{ '确定' }}</el-button>
    </div>
  </el-dialog>
</template>
  
<script>
import { postRelaterApi, noticeApi } from "@/api/fam/famMemberApi";

export default {
  name: "RelaterDialog",

  components: {
    RoleSelector: () => import('@/views/fam/components/RoleSelector.vue')
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    row: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      loading: false,
      formData: {},
      formRules: {
        default_auth: [
          { required: true, message: "权限不能为空", trigger: "blur" },
        ],
        roleid: [
          { required: true, message: "角色不能为空", trigger: "blur" },
        ],
      },
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },

    authArr() {
      return this.$store.state.userStore.is_frippler ? this.$store.state.rmsStore.authArr : this.$store.state.rmsStore.authArr.slice(0, 6);
    },

    is_owner() {
      return this.$store.state.userStore.is_owner;
    },

    memberid() {
      return this.$store.state.userStore.memberid;
    },
  },

  watch: {},

  created() {
    this.formData = Object.assign({}, this.row,{ default_auth: this.$store.state.userStore.is_frippler ? 10 : 5 });
    this.formData.is_relater = +this.row.is_relater;
  },

  methods: {
    getRoleList(list) {
      if (list.length && !this.formData.roleid) {
        this.formData.roleid = list[0].roleid
      }
    },
    submit() {
      this.$refs["postForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          const temp = {
            memberid: this.formData.memberid,
            default_auth: this.formData.default_auth,
            auto_bind: this.formData.auto_bind,
            remark: this.formData.remark,
            roleid: this.formData.roleid,
          };
          postRelaterApi(temp).then((res) => {
            if (!res.errno) {
              this.loading = false;
              this.dialogShow = false;
              this.$message.success(res.message);
              this.$emit("success");
            } else {
              this.loading = false;
              this.$message.error(res.message);
            }
          });
        }
      });
    },

    handleSelect() {
      // this.$nextTick(() => {
      //   this.$refs["postForm"].validateField("default_auth");
      // });
    },

    reNotice() {
      this.$confirm(
        "再次向 " +
          this.formData.nickname +
          " 发送一条成员邀请通知，是否继续？",
        {
          type: "warning",
        }
      )
        .then(() => {
          noticeApi({ memberid: this.formData.memberid }).then((res) => {
            if (!res.errno) {
              this.dialogShow = false;
              this.$emit("success");
              this.$message.success("发送成功");
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },

    onClose() {
      this.dialogShow = false;
    },
  },
};
</script>
  
<style lang="scss">
.relater-dialog {
  .el-dialog__body {
    padding: 30px 25px;
  }
}
</style>
  